import {
  AuthResponse,
  LoginCredentials,
  RegisterData,
  IResidentialUnit,
  ICompanyPartner,
  IIsUnit,
  IIsRealState,
} from '../domain/interfaces/Auth';
import HttpService from './http.service';

// Servicio de autenticación
export const AuthService = {
  // Iniciar sesión
  login: async (credentials: LoginCredentials) => {
    try {
      const response = await HttpService.post<AuthResponse>('/api/auth/login', credentials);
      // Guardar el token en localStorage
      localStorage.setItem('auth_token', response.data.token);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Registrar un nuevo usuario
  register: async (userData: RegisterData) => {
    try {
      const response = await HttpService.post<AuthResponse>('/api/auth/register', userData);
      // Guardar el token en localStorage si el registro también inicia sesión
      localStorage.setItem('auth_token', response.data.token);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllUnits: async () => {
    try {
      const response = await HttpService.get<IResidentialUnit[]>('/api/UnidadesResidenciales/public');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCompanyPartnerByEmail: async (email: string) => {
    try {
      const response = await HttpService.get<ICompanyPartner>(`/api/CompanyPatners/by-email?email=${email}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUnidByEmail: async (email: string) => {
    try {
      const response = await HttpService.get<IIsUnit>(`/api/UnidadesResidenciales/by-email?email=${email}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRealStateByEmail: async (email: string) => {
    try {
      const response = await HttpService.get<IIsRealState>(`/api/Inmobiliarias/by-email?email=${email}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Cerrar sesión
  logout: () => {
    localStorage.removeItem('auth_token');
  },

  // Verificar si el usuario está autenticado
  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('auth_token');
  },

  // Obtener el token actual
  getToken: (): string | null => {
    return localStorage.getItem('auth_token');
  }
};

export default AuthService;
